import classnames from 'classnames'
import React from 'react'

import { OptionContainer } from '../option-container/option-container'
import { OptionProp } from '../OptionSelector.constant'

import styles from './textOption.module.scss'

type TextOptionProps = {
  value: string
  displayName?: string
  disabled?: boolean
  onChange?: (value: string) => void
} & Pick<OptionProp, 'isSelected' | 'selectionSetId' | 'className'>

export const TextOption = ({
  value,
  displayName,
  isSelected,
  selectionSetId,
  disabled,
  className,
  onChange,
}: TextOptionProps) => {
  return (
    <OptionContainer
      value={value}
      displayName={displayName}
      selectionSetId={selectionSetId}
      isSelected={isSelected}
      srOnly={false}
      disabled={disabled}
      inputClassName={styles.input}
      labelClassName={classnames(styles.label, className)}
      onChange={onChange}
    >
      <span>{value}</span>
    </OptionContainer>
  )
}

const TextOptionWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return <TextOption value={optionValue.value} displayName={optionValue.displayName} {...props} />
}

export default TextOptionWithOptionValue
